import { render, staticRenderFns } from "./Modelo.vue?vue&type=template&id=4a817f38"
import script from "./Modelo.vue?vue&type=script&lang=js"
export * from "./Modelo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports